module.exports = __webpack_public_path__ + "static/media/bass-min.11a3c050.jpg";